"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.acceptLicence = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const acceptLicence = exports.acceptLicence = (0, _actionGenerator.actionGenerator)(_types.EAgreementActionTypes.LicenceAccepted);